// @flow

import React from 'react';
import {
  Title, SubTitle,
} from './header.styled';
import type { CartHeaderProps } from '../../types';

export default ({
  make,
  model,
  engine,
  power,
  fueltype,
}: CartHeaderProps) => (
  <header>
    <Title>
      {make}
      {' '}
      {model}
    </Title>
    <SubTitle>
      {engine}
      {' '}
      {power}
      {' '}
      {fueltype}
    </SubTitle>
  </header>
);
